// client/api/services/hotspotRequestService.ts
// Admin service for the hotspot coverage-request feature.
// Mirrors the adminSupportService pattern: named UPPERCASE functions that call
// the shared apiClient (which already attaches the auth token + baseURL /api)
// and return response.data.
//
// Paths are inline here so you don't have to edit the central ENDPOINTS file.
// If you prefer the convention, move them into ENDPOINTS later under
// ADMIN_HOTSPOT_REQUESTS and swap the literals for ENDPOINTS references.

import apiClient from "../client";

const BASE = "/admin/hotspot-requests";

// GET /admin/hotspot-requests/stats -> { success, data: { total, requested, planned, live, declined } }
export const ADMIN_HOTSPOT_REQUEST_STATS = async () => {
  const res = await apiClient.get(`${BASE}/stats`);
  return res.data;
};

// GET /admin/hotspot-requests/clusters?status=&precision=
// -> { success, data: { clusters: [...], totalRequests, precision } }
export const ADMIN_HOTSPOT_REQUEST_CLUSTERS = async (params?: {
  status?: string;
  precision?: number;
}) => {
  const res = await apiClient.get(`${BASE}/clusters`, { params });
  return res.data;
};

// GET /admin/hotspot-requests?status=&search=&page=&limit=
// -> { success, data: [...], pagination }
export const ADMIN_HOTSPOT_REQUEST_LIST = async (params?: {
  status?: string;
  search?: string;
  page?: number;
  limit?: number;
}) => {
  const res = await apiClient.get(BASE, { params });
  return res.data;
};

// PATCH /admin/hotspot-requests/:id/status  body { status, adminNote? }
export const ADMIN_HOTSPOT_REQUEST_SET_STATUS = async (
  id: string,
  status: string,
  adminNote?: string
) => {
  const res = await apiClient.patch(`${BASE}/${id}/status`, { status, adminNote });
  return res.data;
};
